"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Style_1 = require("./Style");
const constant_1 = require("../constants/constant");
const getTenant_1 = __importDefault(require("../utils/getTenant"));
const dataTypes_1 = require("../constants/dataTypes");
const utils_1 = require("../helper/utils");
const localization_json_1 = __importDefault(require("../constants/localization.json"));
const { NOT_IN_APP, NOT_LOGIN, INVALID_RESPONSE, NO_CONNECTION, CUSTOM } = dataTypes_1.E_ERROR;
class ErrorPage extends react_1.Component {
    constructor(props) {
        super(props);
        this.decideText = (type) => {
            const tenantId = getTenant_1.default().toLowerCase();
            const { customMessage, localizationSource } = this.props;
            const source = localizationSource ? localizationSource : localization_json_1.default;
            switch (type) {
                case NOT_IN_APP:
                    return source.errInApp[tenantId];
                case NOT_LOGIN:
                    return source.errLogin[tenantId];
                case INVALID_RESPONSE:
                    return source.errResp[tenantId];
                case NO_CONNECTION:
                    return source.errConnection[tenantId];
                case CUSTOM:
                    return (customMessage || "").split("/n").map((text) => {
                        return react_1.default.createElement(react_1.default.Fragment, null,
                            text,
                            " ",
                            react_1.default.createElement("br", null));
                    });
                default:
                    return;
            }
        };
        this.handleTryAgain = () => {
            const { onRetry } = this.props;
            if (typeof onRetry === 'function') {
                onRetry();
            }
            else {
                window.location.reload();
            }
        };
        this.decideText = this.decideText.bind(this);
        this.handleTryAgain = this.handleTryAgain.bind(this);
    }
    handleLogin() {
        utils_1.goToLogin();
    }
    render() {
        let icon;
        let id = "";
        let buttonOnClick = () => { };
        let buttonId = "";
        let buttonText = "";
        const { customImage, localizationSource, type, customRetryButtonMessage } = this.props;
        const source = localizationSource ? localizationSource : localization_json_1.default;
        const tenantId = getTenant_1.default().toLowerCase();
        switch (type) {
            case INVALID_RESPONSE:
                icon = constant_1.ERR_RESPONSE_IMG_URL;
                id = "img-err-response";
                buttonOnClick = this.handleTryAgain;
                buttonId = "btn-err-response";
                buttonText = source.tryAgainText[tenantId];
                break;
            case NO_CONNECTION:
                icon = constant_1.ERR_CONNECTION_IMG_URL;
                id = "img-err-conn";
                buttonOnClick = this.handleTryAgain;
                buttonId = "btn-err-conn";
                buttonText = source.tryAgainText[tenantId];
                break;
            case NOT_LOGIN:
                icon = constant_1.SHOPEE_LOGO_IMG_URL;
                id = "img-err-shopee";
                buttonOnClick = this.handleLogin;
                buttonId = "btn-err-conn";
                buttonText = source.okText[tenantId];
                break;
            case CUSTOM:
                icon = customImage ? customImage : constant_1.ERR_RESPONSE_IMG_URL;
                id = "img-err-shopee";
                if (customRetryButtonMessage) {
                    buttonText = customRetryButtonMessage;
                }
                break;
            default:
                icon = constant_1.SHOPEE_LOGO_IMG_URL;
                id = "img-err-shopee";
                break;
        }
        return (react_1.default.createElement(Style_1.DivErrorPage, { id: "err-message" },
            react_1.default.createElement(Style_1.ImgGeneral, { src: icon, id: id }),
            this.decideText(type),
            buttonText && (react_1.default.createElement(Style_1.Button, { onClick: buttonOnClick, id: buttonId }, buttonText))));
    }
}
exports.default = ErrorPage;
//# sourceMappingURL=ErrorPage.js.map